export default [
  {
    label: 'KILL/GAME',
    value_key: 'kpg',
    posfix: null,
    text: 'LAST n GAMES',
    className: 'slide-2',
    target: '.frame .slide-2',
  },
  {
    label: 'GULAG',
    value_key: 'gulag',
    posfix: '%',
    text: 'LAST n GAMES',
    className: 'slide-3',
    target: '.frame .slide-3',
  },
  {
    label: 'KD',
    value_key: 'kd',
    posfix: null,
    text: 'LAST n GAMES',
    className: 'slide-4',
    target: '.frame .slide-4',
  },
  {
    label: 'HEADSHOT',
    value_key: 'headshot',
    posfix: '%',
    text: 'LAST n GAMES',
    className: 'slide-5',
    target: '.frame .slide-5',
  },
  {
    label: 'WINS',
    value_key: 'wins',
    posfix: '%',
    text: 'LAST n GAMES',
    className: 'slide-6',
    target: '.frame .slide-6',
  },
  {
    label: 'WINSTREAK',
    value_key: 'winstreak',
    posfix: null,
    text: 'LAST n GAMES',
    className: 'slide-7',
    target: '.frame .slide-7',
  },
  {
    label: 'KILL RECORD',
    value_key: 'kill_record',
    posfix: null,
    text: 'LAST n GAMES',
    className: 'slide-8',
    target: '.frame .slide-8',
  },
];
